import { useState } from 'react';
import Modal from '@mui/material/Modal';
import { IoClose as Close } from 'react-icons/io5';
import { ReactComponent as DeleteIcon } from '@Assets/delete.svg';
import BorderRedButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderRedButtonV2';
import BorderWhiteButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderWhiteButtonV2';
import './DeletePolicyForm.scss';


export default function DeletePolicyForm(props) {

    const [cursor, setCursor] = useState('auto');
    let userSeatExpired = (!!localStorage.userSeatExpired && localStorage.userSeatExpired !== 'undefined')
        ? JSON.parse(localStorage.userSeatExpired) : false;
    const className = 'deletePolicyForm';

    const handleDelete =()=> {
        props.setPolicyList((prev)=> prev.filter(item=> item.id !== props.itemId));
        props.handleRemovePolicy(props?.levelId, props.itemId);
        setCursor('auto');
        props.closePopup();
    };

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}
            onKeyPress={(e) => {
                if (e.key === "Enter") {
                    handleDelete();
                }}}>
                <div className={className}>
                    <div className={className + '__inner flex-column-flex-start'}>
                        <div className={className + '__inner__titleBar flex-row-center-space-between width-wfa'}>
                            <div className={className + '__inner__titleBar__title flex-row-center-0p5rem-gap standard-text-semi-large red-text semi-bold-text'}>
                                <DeleteIcon className={className + '__inner__titleBar__title__icon'}/>Delete Policy
                            </div>
                            <Close className={className + '__inner__titleBar__close close-button'} onClick={props.closePopup}/>
                        </div>
                        <form className={className + '__inner__form flex-column-flex-start width-wfa'} onSubmit={handleDelete}>
                            <div className={className + '__inner__form__info'}>Are you sure you want to delete this Policy?</div>
                            <div className={className + '__inner__form__buttonFlex flex-row-center-1rem-gap width-wfa'}>
                                <div className={className + '__inner__form__buttonFlex__delete width-wfa'}>
                                    <BorderRedButtonV2
                                        text='Delete'
                                        onClick={handleDelete}
                                        disabled={cursor === 'wait' || userSeatExpired}/>
                                </div>
                                <div className={className + '__inner__form__buttonFlex__cancel width-wfa'}>
                                    <BorderWhiteButtonV2
                                        text='Cancel'
                                        onClick={props.closePopup}
                                        disabled={cursor === 'wait'}/>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
        </Modal>
    );
}
